import { useEffect } from "react";

const SOCIAL_SHARE_IMG = "https://customer-assets.emergentagent.com/job_smart-fin-lead/artifacts/a8hbgpj5_Logo%20and%20Favicon.png";

const META_BY_ROUTE = {
  calculator: {
    title: "Finlightenment | Financial Fitness Check",
    description: "See how a 1% shift could change your retirement — without changing your life. Get your free personalized report.",
  },
  quiz: {
    title: "Finlightenment | Financial Fitness Quiz",
    description: "A 90-second quiz to reveal your financial fitness tier — across 6 pillars of money mastery. Free personalized results.",
  },
  audit: {
    title: "Finlightenment | Money Belief Audit",
    description: "The 5 hidden beliefs running your money story — discover the one quietly running the show, with a free personalized report.",
  },
  bridge: {
    title: "Finlightenment | Bridge to Becoming",
    description: "Design the life you deeply desire — vision board, gratitude journal rooted in agency, and bridge affirmations that actually work.",
  },
  admin: {
    title: "Finlightenment | Admin",
    description: "Lead management for the Finlightenment magnet suite.",
  },
};

function setMeta(name, content, isProperty = false) {
  if (!content) return;
  const attr = isProperty ? "property" : "name";
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

/**
 * Sets per-route browser tab title + OG/Twitter meta tags so every magnet
 * has a distinct identity (and shares correctly on social).
 */
export default function useRouteMeta(routeKey) {
  useEffect(() => {
    const meta = META_BY_ROUTE[routeKey] || META_BY_ROUTE.calculator;
    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("og:title", meta.title, true);
    setMeta("og:description", meta.description, true);
    setMeta("og:image", SOCIAL_SHARE_IMG, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", window.location.href, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
    setMeta("twitter:image", SOCIAL_SHARE_IMG);
  }, [routeKey]);
}
